import React from "react";

type NumbereCircleProps = {
    number: number;
    innerColor: string;
    outerColor?: string;
    size: number;
    isPercentage: boolean;
    numberColor: string;
    label: string;
    inverted?: boolean;
}

// arrow function to convert color from percentage between red and green to rgb
const convertColor = (percentage: number, inverted?: boolean) => {
    // hsl from 0 to 150
    const hsl = `hsl(${(inverted ? 100 - percentage : percentage) * 1.5}, 90%, 45%)`;
    // console.log(`hsl: ${hsl}  percentage: ${percentage}`);
    return hsl;
}

// create react component with typescript named NumbereCircle and export as default using memo
const NumberedCircle: React.FC<NumbereCircleProps> = ({ number, innerColor, outerColor, size, isPercentage, numberColor, label, inverted }) => {
    return (
        <svg viewBox={`0 -10 ${size} ${size + 10}`} xmlns="http://www.w3.org/2000/svg">
            <circle cx={size / 2} cy={size / 2} r={size / 2.5} fill={outerColor || convertColor(number, inverted)} />
            <circle cx={size / 2} cy={size / 2} r={size / 4} fill={innerColor} />
            <text x="50%" y="45%" textAnchor="middle" stroke={numberColor} strokeWidth=".1rem" dy=".3rem">{number.toFixed(0)}{isPercentage ? "%" : ""}</text>
            <text x="50%" y="0%" textAnchor="middle" stroke={numberColor} strokeWidth=".3px" dy=".3rem" style={{ fontSize: ".7rem" }}>{label}</text>
        </svg>
    )
}

export default React.memo(NumberedCircle);